var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-col space-y-3"},[_vm._t("default"),(_vm.isError)?_c('div',{staticClass:"text-red mt-2"},[_vm._v(" "+_vm._s(_vm.errorText)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }